export var Path;
(function (Path) {
    Path["base"] = "https://qwerzxvxzvzxvxzv.herokuapp.com/";
    Path["word"] = "words";
})(Path || (Path = {}));
